<template>
<div class="action-table">

        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.course_title"
                :length="2"
            >
            </colored-letter-square>

            <div slot="next_assignment_at"
             slot-scope="props"
        >
            <div v-if="props.row.course_deactivated_at">
                {{ trans('assignments.no_next_assignment_course_deactivated') }}
            </div>
            <div v-else>
                {{ props.row.next_assignment_at }}
            </div>
        </div>
        <div slot="actions" slot-scope="props">
                <AssignmentTableActions
                    :data="props.row"
                    :index="props.index"
                    :user-id="user.id"
                    :debit-clients="debitClients"
                ></AssignmentTableActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    props: ['user', 'debitClients'],

    data() {
        return {
            tableData: [],

            columns: [
                'cls_column',
                'course_title',
                'debit_client',
                'start_date',
                'next_assignment_at',
                'end_date',
                'actions',
            ],

            options: {
                headings: {
                    cls_column: '',
                    course_title: this.trans('assignments.label.course_title'),
                    debit_client: this.trans('assignments.label.debit_client'),
                    start_date: this.trans('assignments.label.start_date'),
                    end_date: this.trans('assignments.label.end_date'),
                    next_assignment_at: this.trans(
                        'assignments.label.next_assignment_at'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['course_title'],
            },
        };
    },

    created() {
        this.fetch();
    },

    mounted() {
        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        EventBus.$on('refreshCourses', () => this.fetch());

        EventBus.$on('courseReassigned', payload => {
            Object.assign(this.tableData[payload[1]], payload[0]);
        });
    },

    methods: {
        fetch() {
            axios
                .get(this.route('tenantapi.assignments.index', this.user.id))
                .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },
};
</script>
